/**
 * Renderer for the Buildings listing name cell.
 *
 * Preserves legacy behavior:
 *  - Name is a link to dataItem.path.
 *  - QB-verified icon shown when dataItem.qbVerified && dataItem.showQbIcons.
 *  - Invalid-address icon shown when dataItem.invalidAddress.
 *
 * IP-15577: icons are read fresh from the row datum on every render — no local state caching.
 * Quimby Table renderer signature: ({ item, dataKey, index }) => ReactNode
 */
import React from 'react';
export function BuildingNameCellRenderer({ item }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: item.path }, item.name),
        item.qbVerified && item.showQbIcons && (React.createElement("img", { height: "16", width: "16", alt: `${item.name}-qb-verified`, src: "/qbo.svg", className: "custom-icon--qbo pull-right", title: "QuickBooks Verified" })),
        item.invalidAddress && (React.createElement("img", { height: "16", width: "16", alt: `${item.name}-invalid`, src: "https://cdn.iconscout.com/icon/premium/png-256-thumb/wrong-position-placeholder-1079464.png", className: "custom-icon--qbo pull-right", title: "Invalid Address" }))));
}
